import {
    NavigationSearchCompany,
    NavigationSearchSite,
} from 'types/Navigation';
import { ResultsType } from './SearchDropdownResults';

export const getIdFromItem = (
    type: ResultsType,
    item: NavigationSearchCompany | NavigationSearchSite
): string => {
    if (type === 'companies') {
        return String((item as NavigationSearchCompany).company_id);
    }
    return String((item as NavigationSearchSite).site_id);
};

type RouteParams = {
    companyId: string | null;
    siteId: string | null;
    '*': string | null;
    page: string | null;
    subpage: string | null;
    group: string | null;
    detail: string | null;
};

export const normalizeRouteParams = (
    baseParams: Record<string, string | undefined> = {},
    overrideIdKey: 'siteId' | 'companyId',
    overrideIdValue: string
): RouteParams => ({
    companyId: overrideIdKey === 'companyId' ? overrideIdValue : null,
    siteId: overrideIdKey === 'siteId' ? overrideIdValue : null,
    '*': baseParams['*'] ?? null,
    page: baseParams.page ?? null,
    subpage: baseParams.subpage ?? null,
    group: baseParams.group ?? null,
    detail: baseParams.detail ?? null,
});
